import * as React from 'react';
import { ViewProp } from '..';
import * as api from '../../api/booking';
import { GetShopCookie } from '../../cookies';
import * as mrCap from '../../mrCapTypes';
import { PageIntro } from '../pageintro';
import { MapWithShops } from './map';
import { getShopBySlug } from '../../util';

interface Props extends ViewProp {
}

interface State {
  shops: mrCap.Shop[];
}

export class LocationSelection extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = {
      shops: []
    };
  };

  async fetchShops() {
    const shops = await api.getShops();

    if (shops && shops.length) {
      this.setState({ shops }, () => {
        const shopSlug = getShopBySlug(shops);

        if (shopSlug && this.props.selectedShop?.id !== shopSlug.id) {
          this.props.setShop(shopSlug);
          this.props.moveNext(true);
          return;
        }

        const shopIdCookie = GetShopCookie();
        const cookieMatch = shops.filter(shop => shop.id === shopIdCookie)[0];

        if (shopIdCookie && cookieMatch) {
          this.props.setShop(cookieMatch);
        }
      });
    }
  }

  componentDidMount() {
    this.fetchShops();
  }

  render() {
    return(
      <div className='outer-page'>
        <div className='page'>

          <div className='page-top-content'>
            <PageIntro
              header={this.props.texts.stepZeroHeader}
              preamble={this.props.texts.stepZeroParagraph} />
          </div>

          <MapWithShops
            {...this.props}
            shops={this.state.shops}
            splitLayout={true}
            shopChangedMessage={this.props.texts.stepTwoShopChangedMessage} />

        </div>
      </div>
    );
  }
}